import React, { Component } from 'react';
import { Container, Accordion, Icon } from 'semantic-ui-react';
import { PtInput, PtSelect, PtRadio } from '../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import DropdownLib from '../../../DropdownLib';

export default class Finance extends Component {
    constructor(props) {
        super(props);
        const { cpModel } = this.props;
        this.state = cpModel.finance;
    }

    render() {
        const { sourceOptions } = DropdownLib.getDropdowns().CP_Finance;
        const yesNoOptions = [
            { key: 0, label: 'N/A', value: 0 },
            { key: 1, label: 'No', value: 1 },
            { key: 3, label: 'Yes', value: 2 }           
        ]
        /**
        TODO: create a list mapping for all of this so we can make these plans dynamic.
        */
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>

                    <Accordion fluid>
                        <Accordion.Title className="accordion-title">
                            <Icon name='dropdown' />
                            Source 1
                        </Accordion.Title>
                        <Accordion.Content>
                            <PtSelect label="Funding Source" options={sourceOptions} defaultVal={this.state.fundingSource} disabled={this.props.disabled}
                                onChange={this.onChangeDropdown} name="fundingSource" />
                            <PtInput inputType="number" placeholder="0" label="%" value={this.state.percent} onChange={this.onInputChange} name="percent" disabled={this.props.disabled} />
                            <PtRadio label="Committed" options={yesNoOptions} value={this.state.committed} disabled={this.props.disabled}
                                onChange={this.onChangeRadio} name="committed" />
                        </Accordion.Content>
                    </Accordion>

                    <Accordion fluid>
                        <Accordion.Title className="accordion-title">
                            <Icon name='dropdown' />
                            Source 2
                        </Accordion.Title>
                        <Accordion.Content>
                            <PtSelect label="Funding Source" options={sourceOptions} defaultVal={this.state.fundingSource2} disabled={this.props.disabled}
                                onChange={this.onChangeDropdown} name="fundingSource2" />
                            <PtInput inputType="number" placeholder="0" label="%" value={this.state.percent2} onChange={this.onInputChange} name="percent2" disabled={this.props.disabled} />
                            <PtRadio label="Committed" options={yesNoOptions} value={this.state.committed2} disabled={this.props.disabled}
                                onChange={this.onChangeRadio} name="committed2" />
                        </Accordion.Content>
                    </Accordion>

                    <Accordion fluid>
                        <Accordion.Title className="accordion-title">
                            <Icon name='dropdown' />
                            Source 3
                        </Accordion.Title>
                        <Accordion.Content>
                            <PtSelect label="Funding Source" options={sourceOptions} defaultVal={this.state.fundingSource3} disabled={this.props.disabled}
                                onChange={this.onChangeDropdown} name="fundingSource3" />
                            <PtInput inputType="number" placeholder="0" label="%" value={this.state.percent3} onChange={this.onInputChange} name="percent3" disabled={this.props.disabled}/>
                            <PtRadio label="Committed" options={yesNoOptions} value={this.state.committed3} disabled={this.props.disabled}
                                onChange={this.onChangeRadio} name="committed3" />
                        </Accordion.Content>
                    </Accordion>

                    <Accordion fluid>
                        <Accordion.Title className="accordion-title">
                            <Icon name='dropdown' />
                            Source 4
                        </Accordion.Title>
                        <Accordion.Content>
                            <PtSelect label="Funding Source" options={sourceOptions} defaultVal={this.state.fundingSource4} disabled={this.props.disabled}
                                onChange={this.onChangeDropdown} name="fundingSource4" />
                            <PtInput inputType="number" placeholder="0" label="%" value={this.state.percent4} onChange={this.onInputChange} name="percent4" disabled={this.props.disabled}/>
                            <PtRadio label="Committed" options={yesNoOptions} value={this.state.committed4} disabled={this.props.disabled}
                                onChange={this.onChangeRadio} name="committed4" />
                        </Accordion.Content>
                    </Accordion>

                    <Accordion fluid>
                        <Accordion.Title className="accordion-title">
                            <Icon name='dropdown' />
                            Source 5
                        </Accordion.Title>
                        <Accordion.Content>
                            <PtSelect label="Funding Source" options={sourceOptions} defaultVal={this.state.fundingSource5} disabled={this.props.disabled}
                                onChange={this.onChangeDropdown} name="fundingSource5" />
                            <PtInput inputType="number" placeholder="0" label="%" value={this.state.percent5} onChange={this.onInputChange} name="percent5" disabled={this.props.disabled} />
                            <PtRadio label="Committed" options={yesNoOptions} value={this.state.committed5} disabled={this.props.disabled}
                                onChange={this.onChangeRadio} name="committed5" />
                        </Accordion.Content>
                    </Accordion>
                    
                </ScrollArea>
            </Container>
        );
    }

    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
    }

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: value === '' ? null : parseFloat(value) });
    }

    onChangeRadio = (e, target) => {
        const { name, value } = target;
        this.props.triggerNeedSave();
        this.setState({ [name]: value });
    }

    componentDidUpdate() {
        console.log(this.state);
        this.props.cpModel.finance = this.state;
    }
}


// WEBPACK FOOTER //
// ./src/layers/tabs/cons-planning/finance.js